import React, { useContext, useState, useEffect } from 'react';
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Box,
  LinearProgress,
  Button
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import AppContext from '../../context';
import CloseIcon from '@material-ui/icons/Close';
import { fetchService, _fetchService } from '../../services/fetch-service';
import isEmpty from '../../utils/isEmpty';
import themeStyles from '../../theme-css';
import { getFieldName, ShowFieldWithInfo } from '../ViewComponents/info-label';
import { SET_STATS_VIEW } from '../../redux/global-state';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StatisticsComponents = ({ clientId, title }) => {
  const dispatch = useDispatch();
  const { setAlertState } = useContext(AppContext);
  const allConfigs = useSelector((state) => state.globalState.allConfigs);
  const statusView = useSelector((state) => state.globalState.statusView);
  const classes = themeStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setloading] = useState(false);
  const [cardConfig, setCardConfig] = useState({});
  const [statisticsData, setStatisticsData] = useState({ fields: {} });

  useEffect(() => {
    if (allConfigs['UI Config'] && allConfigs['UI Config'].stats) {
      setCardConfig(allConfigs['UI Config'].stats);
    }
  }, [allConfigs]);

  const translateHebrewText = (key) => {
    if (allConfigs.Translation && allConfigs.Translation[key]) {
      return allConfigs.Translation[key];
    } else {
      return key;
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    dispatch({
      type: SET_STATS_VIEW,
      payload: false
    });
  };

  useEffect(() => {
    if (statusView) {
      getStatistics();
    }
  }, [statusView]);

  const getStatistics = () => {
    setModalOpen(true);
    setloading(true);
    /* var URL = `/Clients?maxRecords=3&view=UIMenuStats&filterByFormula=%7BRecord%20ID%7D%20%3D%20%27${clientId}%27`; */
    var URL = `/getClientStatistics?clientID=${clientId}`;

    _fetchService('GET', URL)
      .then((res) => {
        setloading(false);
        if (res.status === 200) {
          if (res.data && res.data.records && res.data.records.length > 0) {
            setStatisticsData(res.data.records[0]);
          } else {
            setStatisticsData({});
            setAlertState({
              show: true,
              type: 'error',
              message: 'No Data Found'
            });
          }
        } else {
          setAlertState({
            show: true,
            type: 'error',
            message: res.data.error.message || 'Something went wrong'
          });
        }
      })
      .catch((error) => {
        setAlertState({
          show: true,
          type: 'error',
          message: error.message || 'Something went wrong'
        });
        setloading(false);
      });
  };

  return (
    <>
      <Box style={{ paddingRight: 40, paddingTop: 20 }}>
        {title === 'Mobile' ? null : (
          <Button variant="outlined" onClick={getStatistics}>
            {translateHebrewText('Statistics')}
          </Button>
        )}
      </Box>

      <Dialog
        fullScreen
        open={modalOpen}
        onClose={handleModalClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.addNewLeadappBar}>
          <Toolbar>
            <Typography variant="h6" className={classes.addNewLeadtitle}>
              {translateHebrewText('Statistics')}
            </Typography>
            <IconButton edge="start" color="inherit" onClick={handleModalClose}>
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box className={classes.statisticsWrapper}>
          {loading ? (
            <LinearProgress />
          ) : (
            <>
              {isEmpty(statisticsData) || isEmpty(cardConfig)
                ? null
                : cardConfig.map((config, index) => (
                    <Box className={classes.statisticsinnerWrapper} key={index}>
                      <Typography
                        variant="body1"
                        className={classes.statisticsTitle}
                      >
                        {config.title}
                      </Typography>
                      {isEmpty(config.childrens)
                        ? null
                        : Object.keys(config.childrens).map((keyName, i) => (
                            <React.Fragment key={i}>
                              {isEmpty(
                                statisticsData.fields[keyName]
                              ) ? null : (
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  className={classes.statisticsRow}
                                >
                                  <Box display="flex" alignItems="center">
                                    <Typography variant="caption">
                                      {getFieldName(
                                        config.childrens[keyName],
                                        'label'
                                      )}
                                    </Typography>
                                    <ShowFieldWithInfo
                                      name={config.childrens[keyName]}
                                    />
                                  </Box>

                                  <Typography variant="body2">
                                    {statisticsData.fields[keyName]}
                                  </Typography>
                                </Box>
                              )}
                            </React.Fragment>
                          ))}
                    </Box>
                  ))}
            </>
          )}
        </Box>
      </Dialog>
    </>
  );
};

export default StatisticsComponents;

// <Box className={classes.statisticsinnerWrapper}>
//   {Object.keys(cardConfig).map((keyName, i) => (
//     <Box
//       key={i}
//       display="flex"
//       justifyContent="space-between"
//       className={classes.statisticsRow}
//     >
//       <Box display="flex" alignItems="center">
//         <Typography variant="caption">
//           {getFieldName(cardConfig[keyName], 'label')}
//         </Typography>
//         <ShowFieldWithInfo name={cardConfig[keyName]} />
//       </Box>

//       <Typography variant="body2">
//         {statisticsData.fields[keyName]}
//       </Typography>
//     </Box>
//   ))}
// </Box>
